import { render, staticRenderFns } from "./slideNav.vue?vue&type=template&id=ba8c77d0&scoped=true"
import script from "./slideNav.vue?vue&type=script&lang=js"
export * from "./slideNav.vue?vue&type=script&lang=js"
import style0 from "./slideNav.vue?vue&type=style&index=0&id=ba8c77d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8c77d0",
  null
  
)

export default component.exports